import { gsap } from "gsap";
gsap.defaults({
    ease: "ease"
});

gsap.config({
    nullTargetWarn: false,
    trialWarn: false,
    force3D: false,
    autoSleep: 60
});

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { TextPlugin } from "gsap/TextPlugin";
gsap.registerPlugin(TextPlugin);

import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);
CustomEase.create("json-expo", "0,.69,.2,1");
CustomEase.create("json-easeOut", "0.430, 0.195, 0.020, 1.000");

import jQuery from "jquery";
import "jquery-ui/ui/widgets/datepicker.js";
window.$ = jQuery;
let header = document.getElementsByClassName("header")[0];

let innerH, innerW;

let cy = 5;
let sy = window.pageYOffset;
let yDir = "up";
let deltaY = 0;
let switchUp = 0;
let heroItems, hero;

function pageFullyLoaded(container) {
    initScripts(container);

    let href = window.location.href;
    let libRows = document.querySelectorAll(".lib__row__head");

    if (href.includes("#") && libRows.length > 0) {
        setTimeout(() => {
            let el = href.split("#")[1];
            el = document.getElementById(el);

            if (el) {
                window.scroll({
                    top: window.pageYOffset + el.getBoundingClientRect().top,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }, 500);

    } else {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "auto"
        });
    }

    let tl = gsap.timeline({
        onComplete: () => {
            enableScroll();
            scrollDisabled = false;
        }
    });

    hero = container.getElementsByClassName("hero")[0];

    if (hero) {
        let heroBl = hero.getElementsByClassName("hero__bl");
        let heroCen = hero.getElementsByClassName("hero__center");

        if (heroBl.length > 0) {
            heroItems = heroBl[0].querySelectorAll("*");

        } else if (heroCen.length > 0) {
            heroItems = heroCen[0].querySelectorAll("*");
        }

        gsap.set(heroItems, {
            y: 15,
            opacity: 0,
            duration: 0
        })
    }

    
    loadHero(container, false);

    if (container.dataset.barbaNamespace = "404") {
        gsap.to(".fof__main__title__vid", {
            opacity: 1,
            scale: 1,
            delay: .3,
            duration: .5,
            ease: "ease-in"
        });

        tl.to(".fof__main__sub", {
            opacity: 1,
            duration: .3,
            y: 0,
            ease: "ease-in"
        });
    }

    setTimeout(() => {
        gsap.to("#onetrust-banner-sdk", {
            opacity: 1,
            pointerEvents: "all",
            duration: .3,
            ease: "ease"
        });
    }, 5000);

    return tl;
}

let enableLoader = false;
document.addEventListener("DOMContentLoaded", function () {
    oncePageInit();
    pageFullyLoaded(document.getElementsByClassName("main")[0]);
    fadeNav("in");
})

function loadHero(container, titleAni) {
    if (hero) {
        let tl = gsap.timeline({ delay: 1 });
        tl.fromTo(heroItems, { y: 15, opacity: 0 }, {
            y: 0,
            delay: .1,
            opacity: 1,
            stagger: .2,
            duration: .6,
            ease: "ease"
        });
    }
}

function fadeNav(dir) {
    let tl = gsap.timeline();

    if (dir === "out") {
        document.getElementsByClassName("header__mbl")[0].classList.remove("open");
        document.getElementsByClassName("header__mbl__toggle")[0].classList.remove("active");

        if (document.querySelector(".header__mbl__main__item.active")) {
            document.querySelector(".header__mbl__main__item.active").classList.remove("active");
        }

        tl.to(".header__nav__item__sub", {
            display: "none",
            duration: 0,
            delay: 0
        });

        tl.to(".header__logo", {
            opacity: 0,
            y: -5,
            pointerEvents: "none",
            delay: -.3,
            duration: .1,
            ease: "json-expo"
        });

        gsap.to(".header", {
            pointerEvents: "none",
            duration: 0
        });

        tl.to(".header__nav__item__head", {
            opacity: 0,
            y: -5,
            pointerEvents: "none",
            duration: .7,
            stagger: .03,
            ease: "json-expo"
        });

        tl.to(".header .main__btn", {
            opacity: 0,
            pointerEvents: "none",
            duration: .1,
            ease: "json-expo"
        });

        tl.to(".header__mbl__toggle", {
            opacity: 0,
            pointerEvents: "none",
            duration: .1,
            ease: "json-expo"
        });

    } else {
        gsap.to(".header__nav__item__sub", {
            display: "",
            duration: 0,
            delay: 1.5
        });

        tl.to(".header__logo", {
            delay: 1.2,
            opacity: 1,
            y: 0,
            pointerEvents: "all",
            duration: .2,
            ease: "json-expo"
        });

        tl.to(".header__nav__item__head", {
            opacity: 1,
            y: 0,
            pointerEvents: "all",
            duration: .2,
            stagger: .07,
            ease: "json-expo"
        });

        tl.to(".header .main__btn", {
            opacity: 1,
            pointerEvents: "all",
            duration: .2,
            ease: "json-expo"
        });

        tl.to(".header__mbl__toggle", {
            opacity: 1,
            pointerEvents: "all",
            duration: 1,
            delay: -.5,
            ease: "json-expo"
        });

        tl.to(".header", {
            pointerEvents: "all",
        });
    }
}
// Scripts run each page load (also run on init)
function initScripts(container) {

    if (!("ontouchstart" in document.documentElement)) {
        initParallax();
    }

    initScaleBlocks();

    if (document.querySelector("body.archive") || document.querySelector('body.page-template-template-customer-stories-archive') || document.querySelector("body.page-template-template-open-positions")) {
        import(`./assets/js/archive`);
    }
    if (document.querySelector(".c-share-post")) {
        import(`./assets/js/share-post`);
    }
    if (document.querySelector("canvas.hero__bg")) {
        import(`./assets/js/hero-webgl`).then((imp) => imp.default());
    }
    if (document.querySelector(".hero__ctas")) {
        import(`./assets/js/hero-ctas`).then((imp) => imp.default());
    }
    if (document.querySelector(".testimonial")) {
        import(`./assets/js/testimonial`).then((imp) => imp.default());
    }
    if (document.querySelector(".awards__body__inner")) {
        import(`./assets/js/side-slider`).then((imp) => imp.default());
    }
    if (document.querySelector(".scr-panel")) {
        import(`./assets/js/pins`).then((imp) => imp.default());
    }
    if (document.querySelector(".listing")) {
        import(`./assets/js/listing`).then((imp) => imp.default());
    }
    if (document.querySelector(".c-team")) {
        import(`./assets/js/team`).then((imp) => imp.default());
    }
    if (document.querySelector(".timeline")) {
        import(`./assets/js/timeline`).then((imp) => imp.default());
    }
    if (document.querySelector(".article__body__block__video__media, .scr-panel__sticky__img--frame")) {
        import(`./assets/js/videos`).then((imp) => imp.default());
    }
    if (document.querySelector(".c-horizontal-accordion")) {
        import(`./assets/js/horizontal-accordion`);
    }
    if (document.querySelector(".c-document-types")) {
        import(`./assets/js/document-types`);
    }
    if (document.querySelector(".c-reports-carousel")) {
        import(`./assets/js/reports-carousel`);
    }
    if (document.querySelector(".c-sections-anchors")) {
        import(`./assets/js/sections-anchors`);
    }
    if (document.querySelector(".post-anchors-container")) {
        import(`./assets/js/post-anchors`);
    }

    headerTheme(container);
    initDropdowns();
    initCheckboxes();
    initCardHovers();
    initAutoplayVideos()

    initColourTheme(container);
    initServices();
    initDatepicker();

    setTimeout(() => {
        storeAllUTMs()
    }, 1000);

    switchUp = 0;
}

function initColourTheme(container) {
    let theme = container.dataset.colourTheme;

    if (theme) {
        let primaryColBlocks = document.querySelectorAll(".bg-col--primary");
        let secondaryColBlocks = document.querySelectorAll(".bg-col--secondary");

        primaryColBlocks.forEach(primaryColBlock => {
            primaryColBlock.classList.add("bg-col--" + theme);
        });
        secondaryColBlocks.forEach(secondaryColBlock => {
            secondaryColBlock.classList.add("bg-col--" + theme + "--secondary");
        });


        let primaryTextColBlocks = document.querySelectorAll(".text-col--primary");
        let secondaryTextColBlocks = document.querySelectorAll(".text-col--secondary");

        primaryTextColBlocks.forEach(primaryColBlock => {
            primaryColBlock.classList.add("text-col--" + theme);
        });
        secondaryTextColBlocks.forEach(secondaryColBlock => {
            secondaryColBlock.classList.add("text-col--" + theme + "--secondary");
        });

        let fadedHeads = document.querySelectorAll(".hero__bl--faded");
        fadedHeads.forEach(fadedHead => {
            fadedHead.classList.add("text-col--" + theme + "--secondary");
        });
    }
}

ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange, DOMContentLoaded, load" // notice "resize" isn't in the list
    // ignoreMobileResize: true,
});

// Only scripts to be initted on first site visit. Above function also run on first visit.
function oncePageInit(container) {
    let calcVp;
    (calcVp = () => {
        // scrollTrigger.refresh();
        innerH = window.innerHeight;
        innerW = window.innerWidth;
    })();

    window.addEventListener("resize", calcVp);

    initScroller();
    anchorScrRefresh();
    scrollHeader();
    headerMobileNavToggle();
    headerSubNavToggle();
    initFooterLottie();
    initFilterSticky();
}

// Load following only after entire page is loaded
window.addEventListener("load", (event) => {
    initLazyLoad()
});
function initScroller() {
    sy = window.pageYOffset;

    document.addEventListener("scroll", function (e) {
        sy = window.pageYOffset;
    });

    document.addEventListener("wheel", function (e) {
        deltaY = e.deltaY;
        yDir = (deltaY > 0 ? "down" : "up");
    });
}

let rsParallaxArr, relObj;
const offsetDiff = .06;
const fric = .8;
function initParallax() {
    //Stores all elements to have parallax
    rsParallaxArr = document.getElementsByClassName("rs-parallax");
    relObj = {};

    //For each of these elements- set perspective and overflow hidden on parent element
    for (let i = 0; i < rsParallaxArr.length; i++) {
        rsParallaxArr[i].parentNode.style.overflow = "hidden";

        //Store offset from top for calculation
        relObj[i] = { "offset": rsParallaxArr[i].offsetHeight };
    }

    calcParallax();

    //Run every animation frame tick
    window.animateFrame = () => {
        //Run only when sy has changed (User has scrolled)
        //Cant use equal param. Two numbers are never the same, so use a range. Larger the range, the less smooth the animation but less the code is fired.
        if (Math.abs(cy - sy) > .2) {
            //Calculate momentum pos using linear interpolation - easing function
            cy = (1 - fric) * cy + fric * sy;

            calcParallax();
        }

        window.requestAnimationFrame(animateFrame);
    };

    animateFrame();
}

function calcParallax() {
    for (let i = 0; i < rsParallaxArr.length; i++) {
        let gbcr = rsParallaxArr[i].getBoundingClientRect();

        if ((gbcr.top <= innerH) && (gbcr.bottom >= 0)) {
            let normalized = (-gbcr.top)

            // Divide for desired effect
            rsParallaxArr[i].style.transform = `translateY(${normalized / 8}px) scale(1.1)`;
        }
    }
}

// Get header height and add to <body> element as CSS variable
const headerHeight = () => {
    let body = document.querySelector('body');
    let header = document.querySelector('header');
    let adminBar = document.querySelector('#wpadminbar');
    let headerHeight = header.offsetHeight;

    body.style.setProperty("--header-height", `${headerHeight}px`);

    if (!!adminBar) {
        header.style.setProperty('margin-top', `${adminBar.offsetHeight}px`);
    }
}
['load', 'resize'].forEach((event) => {
    window.addEventListener(event, headerHeight);
});

// If the page theme if light then add class to header
const headerTheme = (container) => {
    if (container.dataset.headerTheme === "light" || !!document.querySelector('.c-hero.bkg-theme-dark')) {
        header.classList.add("header-light");
    }
}

//If scrolling down then hide header, and if scrolling up then show header
//Also handles the color changing on scrolled vs at the top of page
const scrollHeader = () => {
    let lastScrollTop = 0;

    document.addEventListener("scroll", function (e) {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            // downscroll code
            header.classList.add('header-hidden');
        } else if (scrollTop < lastScrollTop) {
            // upscroll code
            header.classList.remove('header-hidden');
        }
        if (scrollTop > 0) {
            header.classList.add('header-scrolled');
        } else {
            header.classList.remove('header-scrolled');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    });    
}

// Add listener for mobile nav toggle && always remove when resizing to desktop
const headerMobileNavToggle = () => {
    const header = document.querySelector('header');
    const mobileNavToggleBtn = document.querySelector('.mobile-menu-toggle');

    mobileNavToggleBtn.addEventListener('click', () => {
        header.classList.toggle('mobile-menu-active')
    })

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 900) {
            header.classList.remove('mobile-menu-active')
        }
    });
}

// Subnav toggle listener
const headerSubNavToggle = () => {
    const headerSubNavToggleBtns = document.querySelectorAll('header .subnav-toggle');

    for (let headerSubNavToggleBtn of headerSubNavToggleBtns) {
        headerSubNavToggleBtn.addEventListener('click', (e) => {
            let parentLink = headerSubNavToggleBtn.parentNode
            parentLink.classList.toggle('subnav-active')
        })
    }
}
/*
 * Initialize animations upon scroll into view by adding a class, and then CSS keyframe animations do the rest
 *
 */
const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
const observerOptions = {
    threshold: 0.33,
}
const animateEls = document.querySelectorAll("[class*='anim-']");
let animTimeline = gsap.timeline({defaults: {duration:0.5, ease:'cubic-bezier(.87,0,.13,1)'}});


// Animate elements when in view via GSAP Timeline
let observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            let el = entry.target
            observer.unobserve(el);
            let delayAmt = (!!el.style.getPropertyValue('animation-delay') ? parseFloat(el.style.getPropertyValue('animation-delay').replace('s','')) : 0); //If animation-delay CSS property set for element (like other anim- classes use) then use that for delay, otherwise fallback to 0s
            let tlRecentEl = (!!animTimeline.recent() ? animTimeline.recent()._targets[0] : false); //Get the most recently added child tween element if exists
            
            
            // anim-clipreveal-left
            if (el.classList.contains("anim-clipreveal-left")) {
                // If prevTimelineEl had same anim as el then animate it in faster
                if (animTimeline.isActive() && !!tlRecentEl && tlRecentEl.classList.contains("anim-clipreveal-left")) {
                    animTimeline.set(el, {opacity:1, clipPath:'inset(0 0 0 100%)'}, ">-0.33");
                    animTimeline.to(el, {delay:delayAmt, clipPath:'inset(0 0 0 0%)'});
                } else {
                    animTimeline.set(el, {opacity:1, clipPath:'inset(0 0 0 100%)'});
                    animTimeline.to(el, {delay:delayAmt, clipPath:'inset(0 0 0 0%)'});
                }

            // anim-clipreveal-right
            } else if (el.classList.contains("anim-clipreveal-right")) {
                // If prevTimelineEl had same anim as el then animate it in faster
                if (animTimeline.isActive() && !!tlRecentEl && tlRecentEl.classList.contains("anim-clipreveal-right")) {
                    animTimeline.set(el, {opacity:1, clipPath:'inset(0 100% 0 0)'}, ">-0.33");
                    animTimeline.to(el, {delay:delayAmt, clipPath:'inset(0 0% 0 0)'});
                } else {
                    animTimeline.set(el, {opacity:1, clipPath:'inset(0 100% 0 0)'});
                    animTimeline.to(el, {delay:delayAmt, clipPath:'inset(0 0% 0 0)'});
                }

            // anim-fade-in
            } else if (el.classList.contains("anim-fade-in")) {
                // If prevTimelineEl had same anim as el then animate it in faster
                if (animTimeline.isActive() && !!tlRecentEl && tlRecentEl.classList.contains("anim-fade-in")) {
                    animTimeline.to(el, {delay:delayAmt, opacity:1}, ">-0.33");
                } else {
                    animTimeline.to(el, {delay:delayAmt, opacity:1});
                }

            // anim-fade-in-up
            } else if (el.classList.contains("anim-fade-in-up")) {
                // If prevTimelineEl had same anim as el then animate it in faster
                if (animTimeline.isActive() && !!tlRecentEl && tlRecentEl.classList.contains("anim-fade-in-up")) {
                    animTimeline.to(el, {delay:delayAmt, opacity:1, y:0}, ">-0.33");
                } else {
                    animTimeline.to(el, {delay:delayAmt, opacity:1, y:0});
                }

            // anim-typewriter-letters
            } else if (el.classList.contains("anim-typewriter-letters")) {
                animTimeline.set(el, {opacity:1});
                let typewriterTextLetters = el.querySelectorAll("tw-letter");
                animTimeline.to(typewriterTextLetters, {
                    opacity: 1,
                    duration: 0.15,
                    delay: delayAmt,
                    stagger: (index, target, list) => {
                        //Randomize the delay between each stagger 
                        return randomStagger(index, 0.015);
                    }
                });

            // anim-typewriter-words
            } else if (el.classList.contains("anim-typewriter-words")) {
                animTimeline.set(el, {opacity:1});
                let typewriterTextWords = el.querySelectorAll("tw-word");
                animTimeline.to(typewriterTextWords, {
                    opacity: 1,
                    duration: 0.1,
                    delay: delayAmt,
                    stagger: (index, target, list) => {
                        //Randomize the delay between each stagger
                        return randomStagger(index, 0.1);
                    }
                });
            }
        }
    });
}, observerOptions);
// If visitor does NOT prefers-reduced-motion then observe them to call animate function
if (!prefersReducedMotion) {
    for (const el of animateEls) {
        observer.observe(el)
    }
}

// If visitor does NOT prefers-reduced-motion then add scroll listener to check if currently loading anim is out of view then seek tl to the end of that anim time
if (!prefersReducedMotion) {
    let lastKnownScrollPosition = 0;
    let scrollingDown = true;

    document.addEventListener('scroll', function(e) {
        // If something in the timeline is running
        if (animTimeline.isActive()) {
            scrollingDown = (lastKnownScrollPosition < window.scrollY); //If last scroll position was less than current scroll position then we are going down
            lastKnownScrollPosition = window.scrollY;
            const tlTotalTime = animTimeline.totalTime();
            const tlChildren = animTimeline.getChildren(false, true, true);
            
            // Loop through all children in the timeline
            for (let tlChild of tlChildren) {

                // If the end of this timeline child is later than the current position of the timeline
                if (tlChild._end > tlTotalTime) {
                    let lastTarget = tlChild._targets.length - 1;
                    let tlFirstChildEl = tlChild._targets[0];
                    let tlLastChildEl = tlChild._targets[lastTarget];

                    // If scrolling down and the tlLastChildEl is above the fold or scrolling up and the tlFirstChildEl is below the fold then move the timeline to this anim's end time so the next animation can start
                    if ((scrollingDown && tlLastChildEl.getBoundingClientRect().bottom < 0) || (!scrollingDown && tlFirstChildEl.getBoundingClientRect().top > window.innerHeight)) {
                        let tlChildEnd = tlChild._end;
                        animTimeline.seek(tlChildEnd);
                    }
                }
            }
        }
    });
}

// Typewriter letter split for both HTML and text content of a childNode
const letterHTMLReplace = (childNode) => {
    //Helper function to decode HTML encoded entities, like <>'&;
    const decodeHTMLEntities = (text) => {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    // If the textContent is not just spaces and new line
    if (!!(/[^\s\\]/.test(childNode.textContent))) {
        // If this is HTML and doesn't already contain <tw-letter> HTML we'll replace innerHTML, otherwise it's a #text node and we'll use replaceWith to replace the textContent
        if (!!childNode.innerHTML && (!(/tw\-letter/.test(childNode.outerHTML)))) {
            let elInnerHTML = decodeHTMLEntities(childNode.innerHTML); //Decode HTML encoded entities, especially for ampersand (&)
            let elLetters = elInnerHTML.split("");
            let elInnerHTMLNew = '';

            for (let [index, elLetter] of elLetters.entries()) {
                if (!(/\s+/.test(elLetter))) {
                    elLetter = `<tw-letter>${elLetter}</tw-letter>`;
                }
                elInnerHTMLNew += elLetter;
            }
            childNode.innerHTML = elInnerHTMLNew;
        } else {
            let elInnerHTML = childNode.textContent;
            let elLetters = elInnerHTML.split("");
            let elInnerHTMLNew = document.createElement('span'); //Create a new element that we'll need later for replaceWith()

            for (let [index, elLetter] of elLetters.entries()) {
                if (!(/\s+/.test(elLetter))) {
                    elLetter = `<tw-letter>${elLetter}</tw-letter>`;
                }
                elInnerHTMLNew.innerHTML += elLetter;
            }
            childNode.replaceWith(...elInnerHTMLNew.childNodes);
        }
    }
};
// Loop through all typewriter letter elements, if they are not #text node then loop again until you get to #text node
// then use helper function letterHTMLReplace() to wrap the letters with a <tw-letter> element
const createTypewriterTextLetters = (el) => {
    let elChildNodes = el.childNodes;

    if (!!elChildNodes.length) {
        for (let elChildNode of elChildNodes) {
            if (elChildNode.childNodes.length > 1 || (!!elChildNode.firstChild && elChildNode.firstChild.nodeName !== "#text")) {
                createTypewriterTextLetters(elChildNode);
            } else {
                letterHTMLReplace(elChildNode);
            }
        }
    }
};
// Typwriter word split
const createTypewriterTextWords = (el) => {
    let elHTML = el.innerHTML;
    elHTML = elHTML.trim().replace(/\n/g, "");
    let elWords = elHTML.split(" ");
    el.innerHTML = "";

    for (let [index, elWord] of elWords.entries()) {
        elWord = `<tw-word>${elWord}</tw-word>`;
        el.innerHTML += elWord;
        if (index < elWords.length - 1) {
            el.innerHTML += " ";
        }
    }
};
// Loop through all anim-typerwriter els and update HTML (if they don't prefers-reduced-motion)
if (!prefersReducedMotion) {
    for (let el of animateEls) {
        if (el.classList.contains("anim-typewriter-letters")) {
            createTypewriterTextLetters(el);
        }
        if (el.classList.contains("anim-typewriter-words")) {
            createTypewriterTextWords(el);
        }
    }
}
/**
 * Helper function to get stagger amount
 * This gets a random stagger amount between each GSAP element by utilizing Math.random()
 * @param {int} index - The index of the GSAP element
 * @param {int} staggerAmt - The stagger amount between elements as seconds (e.g. 1, 0.3, 0.005) 
 */
const randomStagger = (index, staggerAmt) => {
    return (index * staggerAmt) + (Math.random() * staggerAmt);
}


/*
 * Legacy animations
 *
 */
function initScaleBlocks(){
    let scaleBlocks = document.querySelectorAll(".listing__right, .scr-panel__sticky--ui");

    gsap.to(scaleBlocks, {
        scale: .8
    });

    gsap.to(scaleBlocks.children, {
        scale: 1.2
    });

    scaleBlocks.forEach(scaleBlock => {
        gsap.to(scaleBlock, {
            scrollTrigger: {
                trigger: scaleBlock,
                once: true,
                start: "top bottom",
    
                onEnter: () => {
                    gsap.to(scaleBlock, {
                        scale: 1,
                        ease: "json-easeOut",
                        duration: 1.8
                    });

                    gsap.to(scaleBlock.children, {
                        scale: 1, 
                        ease: "json-easeOut",
                        duration: 1.8
                    });
                },
            },
        });
    });
}
// This file is for smaller script components- if a script component is large consider creating a new file
const laptopBp = 1152;

function initDropdowns() {
    let dropdownRows = document.querySelectorAll(".filter__row > .filter__row__head");

    dropdownRows.forEach(row => {
        row.addEventListener("click", function () {
            this.parentElement.classList.toggle("open");
        });
    });

    let dropdownConts = document.querySelectorAll(".filter__head");
    dropdownConts.forEach(dropdownCont => {
        dropdownCont.addEventListener("click", function () {
            this.parentElement.classList.toggle("open");
        });
    });
}

function initFilterSticky() {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 1152px)", () => {
        gsap.to(".filter--sticky:not(.filter--sticky--no-stick)", {
            scrollTrigger: {
                trigger: ".filter--sticky:not(.filter--sticky--no-stick)",
                start: "top top+=30",
                endTrigger: ".two-col__left",
                end: "bottom bottom",
                pin: true,
                pinSpacing: false,
            }
        })
    })
}

function initCheckboxes() {
    let checkboxRows = document.querySelectorAll(".filter__row__dropdown__radio");

    checkboxRows.forEach(row => {
        row.getElementsByTagName("input")[0].addEventListener("change", function () {
            if (this.checked) {
                row.classList.add("checked");

            } else {
                row.classList.remove("checked");
            }
        });
    });
}

function initCardHovers() {
    let cards = document.querySelectorAll(".solutions__cards__item, .tabs__grid__item");

    cards.forEach(card => {
        let vid = card.getElementsByTagName("video")[0];

        if (vid) {
            if (vid.readyState < 3) {
                vid.addEventListener("loadeddata", () => {
                    if (vid.readyState >= 3) {
                        setTimeout(() => {
                            vid.play();
                        }, 500);
                    }
                });

            } else {
                setTimeout(() => {
                    vid.play();
                }, 500);
            }
        }
    });
}

function refreshScrollTrigger() {
    ScrollTrigger.refresh();
    ScrollTrigger.update();
}

function initServices() {
    let services = document.querySelectorAll(".services__main");

    services.forEach(service => {
        let serviceBtns = service.querySelectorAll(".services__main__controls > .main__btn");

        serviceBtns.forEach(serviceBtn => {

            serviceBtn.addEventListener("click", function (e) {
                service.querySelectorAll(".main__btn.active--black")[0].classList.remove("active--black");
                e.target.classList.add("active--black");

                let i = Array.prototype.indexOf.call([...serviceBtns], this);
                service.querySelectorAll(".services__main__inner.active")[0].classList.remove("active");
                service.querySelectorAll(".services__main__inner")[i].classList.add("active");
            });

        });
    });
}

import bodymovin from "lottie-web/build/player/lottie_light_canvas";

function initFooterLottie() {
    const footerLogo = document.querySelector(".footer-logo-animation");

    let footerLottie = bodymovin.loadAnimation({
        container: footerLogo,
        path: footerLogo.dataset.url,
        renderer: "canvas",
        loop: false,
        autoplay: false
    });

    // Fire above Lottie anim when in view
    let observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                let el = entry.target
                observer.unobserve(el);

                footerLottie.play();
            }
        });
    }, observerOptions);
    // If visitor does NOT prefers-reduced-motion then observe
    if (!prefersReducedMotion) {
        observer.observe(footerLogo);
    }
}

let scrollTop;
let scrollDisabled = false;
export function disableScroll() {
    // Get the current page scroll position
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollDisabled = true;

    document.querySelector(".header")?.classList.add("header--scroll-disabled")

    // if any scroll is attempted, set this to the previous value
    window.onscroll = function () {
        document.body.scrollTop = document.documentElement.scrollTop = document.scrollingElement.scrollTop = scrollTop;
    };
}

export function enableScroll() {
    scrollDisabled = false;
    window.onscroll = function () { };
    document.querySelector(".header")?.classList.remove("header--scroll-disabled")
}

function anchorScrRefresh() {
    let anchors = document.querySelectorAll("a");

    anchors.forEach(anchor => {
        if (anchor.href.includes("#")) {
            anchor.addEventListener("click", function () {
                refreshScrollTrigger();

                setTimeout(() => {
                    refreshScrollTrigger();
                }, 500);
            });
        }
    });
}

function initAutoplayVideos() {
    const videos = document.querySelectorAll("video.autoplay");

    videos.forEach(video => {
        gsap.to(video, {
            scrollTrigger: {
                trigger: video,
                start: "top bottom",
                end: "bottom top",
                onEnter: () => video.play(),
                onEnterBack: () => video.play(),
                onLeave: () => video.pause(),
                onLeaveBack: () => video.pause(),
            }
        })
    });
}

let urlParams = new URLSearchParams(window.location.search);
function storeUTM(utmName, inputName){
    // Check for sessionStorage value of UTM
    let utmValue = sessionStorage.getItem(utmName);
    // If there is a value in the current UTM param then save to utmValue var and set as sessionStorage value
    if (!!urlParams.get(utmName)) {
        utmValue = urlParams.get(utmName);
        sessionStorage.setItem(utmName, utmValue);
    }
    // Check for input with the UTM name and if it exists and the utmValue var exists then set the input value
    const input = document.querySelector(`input[name='${inputName}']`)
    if(!input || !utmValue) return;
    input.setAttribute("value", utmValue);
}

function storeAllUTMs() {
    storeUTM("utm_source", "utm_source");
    storeUTM("utm_medium", "utm_medium");
    storeUTM("utm_campaign", "utm_campaign");
    storeUTM("utm_content", "utm_content");
    storeUTM("utm_term", "utm_term");
    storeUTM("utm_adgroup", "utm_adgroup");
}

// Add dataLayer event for HubSpot form submission
window.addEventListener("message", function(event) {
    if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        console.log('event data: ', event.data);
        window.dataLayer.push({
            'event': 'hubspot-form-submit',
            'hs_form_guid': event.data.id
        });
    }
});
let enableDays;
function enableAllTheseDays(date) {
    var sdate = $.datepicker.formatDate("dd-mm-yy", date);
    for (var prop in enableDays) {
        if (enableDays[sdate]) {
            var result = enableDays[sdate].split("|");
            var selectable = true;
            var classname = "";
            var title = result[1].replace(/(<([^>]+)>)/gi, "");
            return [selectable, classname, title];
            break;
        }
    }
    return [false];
}

function initDatepicker() {
    if ($(".change-date").length) {
        $(".change-date").click(function () {
            $(".embed-form-calender").removeClass("hide");
            $(".embed-form").addClass("hide");
        });
    }
    if ($(".null-date").length) {
        $(".null-date").click(function () {
            if ($("#nulldate").is(":checked")) {
                $(".copy h5").html("Pre Recorded");
                $("input[name*='Recurring_Demo_Date__c']").val($("#nulldate").val());
                $(".embed-form-calender").addClass("hide");
                $(".embed-form").removeClass("hide");
            }
        });
    }

    if ($(".datepicker").length) {
        enableDays = JSON.parse(document.getElementById("enableDays").innerText);

        $(".datepicker").datepicker({
            dateFormat: "dd-mm-yy",
            beforeShowDay: enableAllTheseDays,
            minDate: new Date(),
            onSelect: function (dateText, inst) {
                $(".embed-form-calender").addClass("hide");
                $(".embed-form").removeClass("hide");
                $(".copy h5").html(enableDays[dateText]);
                $("input[name*='Recurring_Demo_Date__c']").val(dateText);
            }
        });
    }
}

function filterIt(arr, searchKey) {
    return arr.filter(obj => Object.keys(obj).some(key => obj[key].includes(searchKey)));
}

const initLazyLoad = () => {
    /*
    // Lazy loaded images
    */
    const lazyImgs = document.querySelectorAll('img[data-src]:not([data-src=""]')
    const lazyImgsObserverOptions = {
    rootMargin: '200px', //RootMargin declares where it will trigger the observer (optional). 200px means when you scroll to within 200px of the image
    };
    if (!!lazyImgs.length) {
        let observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let el = entry.target;
                    observer.unobserve(el);

                    el.dataset.src ? el.src = el.dataset.src : '';
                    el.dataset.srcset ? el.srcset = el.dataset.srcset : '';
                    el.dataset.sizes ? el.sizes = el.dataset.sizes : '';
                }
            });
        }, lazyImgsObserverOptions);

        for (let img of lazyImgs) {
            observer.observe(img);
        }
    }


    /*
    // Lazy loaded background images
    */
    const lazyBkgEls = document.querySelectorAll('*[data-bkg]:not([data-bkg=""]')
    const lazyBkgElsObserverOptions = {
    rootMargin: '200px', //RootMargin declares where it will trigger the observer (optional). 200px means when you scroll to within 200px of the image
    };
    if (!!lazyBkgEls.length) {
        let observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let el = entry.target;
                    observer.unobserve(el);

                    el.dataset.bkg ? el.style.backgroundImage = `url("${el.dataset.bkg}")` : '';
                }
            });
        }, lazyBkgElsObserverOptions);

        for (let el of lazyBkgEls) {
            observer.observe(el);
        }
    }
}